import ArtDirectionImage from '@/app/components/Image/ArtDirectionImage';
import Motion from '@/app/components/Motion';

const GutfHeroBackground = () => {
  return (
    <Motion
      className="relative z-10 h-full"
      animate={{ opacity: 1, scale: 1 }}
      initial={{ opacity: 0, scale: 1.1 }}
      transition={{ duration: 1.5, type: 'tween' }}
    >
      <ArtDirectionImage
        className="object-cover"
        fill
        localizedAlt="gutf_hero_img_alt"
        priority
        sizes="100vw"
        srcSet={[
          {
            media: '(max-width: 1023px)',
            src: 'gutf-campaign/gutf-hero-mobile-2.jpg?ar=1:1&fit=crop&crop=focalpoint&fp-x=0.7&fp-y=0.6&fp-z=0.77',
          },
          {
            media: '(min-width: 1024px)',
            src: 'gutf-campaign/gutf-hero.jpg?ar=3:2&fit=crop&crop=focalpoint&fp-x=0.48&fp-y=0.6&fp-z=1.12',
          },
        ]}
      />
      <div className="absolute bottom-0 z-10 h-1/2 w-full bg-linear-to-b from-transparent to-[#100604] to-65% lg:hidden" />
      <div className="absolute z-10 hidden h-full w-full bg-linear-246 from-transparent from-65% to-black/50 to-98% lg:block" />
      <div className="absolute z-10 h-full w-full bg-linear-10 from-transparent from-78% to-black/50 to-89% lg:from-68%" />
    </Motion>
  );
};

export default GutfHeroBackground;
